import { TypeCategorySkeleton } from "#/types/contentful"
import { EntryWithoutUnresolvableLinks, ReadLearnArticleEntry } from "#/utils/ContentTypes"
import { Category, mapContentToCategory } from "./CategoryMapper"

export type BookmarkEntryWithMatchingCategory = {
  article: ReadLearnArticleEntry
  category: Category
  contentTypeId: string
  articleId: string
}

export const mapContentToBookmarkEntry = (
  article: ReadLearnArticleEntry,
  category: EntryWithoutUnresolvableLinks<TypeCategorySkeleton>
): BookmarkEntryWithMatchingCategory => {
  return {
    article: article,
    category: mapContentToCategory(category),
    contentTypeId: article.sys.contentType.sys.id,
    articleId: article.sys.id
  }
}
